import { brand, neutrals, social, alert } from 'src/theme/colors';
import { StyleSheet } from 'react-native';

const sharedStyle = StyleSheet.create({
  text: {
    alignItems: 'center',
    gap: 8,
  },
  description: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
    maxWidth: 506,
  },
  buttonPrimary: {
    width: 200,
    borderRadius: 25,
    paddingVertical: 11,
    backgroundColor: brand.main.water,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 4,
  },
  buttonPrimaryDisabled: {
    backgroundColor: neutrals.neutralGrays.dust,
    shadowOpacity: 0,
  },
  buttonPrimaryText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    textAlign: 'center',
    color: neutrals.white,
  },
  buttonPrimaryTextDisabled: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    textAlign: 'center',
    color: neutrals.neutralGrays.ash,
  },
  buttonSecondary: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 305,
    borderRadius: 100,
    paddingVertical: 13,
    paddingHorizontal: 30,
    gap: 10,
    borderWidth: 1,
    backgroundColor: neutrals.white,
    borderColor: neutrals.neutralGrays.snow,
    shadowColor: neutrals.neutralGrays.dust,
    shadowOffset: {
      width: 2,
      height: 2,
    },
    shadowRadius: 4,
  },
  buttonSecondaryText: {
    fontWeight: 700,
    fontSize: 18,
    lineHeight: 27,
    color: social.googlePhotos,
  },
  textError: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  textErrorBold: {
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 24,
    color: alert.alertRed,
  },
  googlePhotoIconSmall: {
    width: 20,
    height: 20,
  },
});

export const styleDesktop = StyleSheet.create({
  ...sharedStyle,
  modalContainer: {
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
  },
  wrapperContainer: {
    gap: 24,
    alignItems: 'center',
    flexDirection: 'column',
  },
  container: {
    backgroundColor: brand.main.variations['lighterWater-3'],
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    gap: 39,
    paddingVertical: 32,
  },
  content: {
    alignItems: 'center',
    gap: 24,
  },
  googlePhotoIcon: {
    width: 80,
    height: 80,
  },

  title: {
    fontWeight: 700,
    fontSize: 20,
    lineHeight: 28,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  errorWrapper: {
    height: 80,
  },
});

export const styleMobile = StyleSheet.create({
  ...sharedStyle,
  modalContainer: {
    flexDirection: 'column-reverse',
    gap: 20,
  },
  wrapperContainer: {
    gap: 24,
    alignItems: 'center',
    flexDirection: 'column-reverse',
  },
  container: {
    backgroundColor: neutrals.white,
    height: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 20,
    gap: 39,
  },
  content: {
    alignItems: 'center',
    gap: 24,
    width: 295,
  },
  googlePhotoIcon: {
    width: 70,
    height: 70,
  },
  title: {
    fontWeight: 700,
    fontSize: 22,
    lineHeight: 31,
    color: neutrals.neutralGrays.graphite,
    textAlign: 'center',
  },
  errorWrapper: {
    width: 327,
  },
});
